import {Component, Inject,  Input, OnInit} from 'ng-metadata/core';


@Component({
    'selector': 'prm-facet-group',
    templateUrl: 'components/search/facet/facet-group.html'
})

export class PrmFacetGroup implements OnInit{
    @Input() private displayedType: any;
    @Input() private facetGroup: any;
    @Input() private facetType:string;




    /* private fields */

    private _facetGroupHeader: string;



        constructor(
                @Inject('$translate') private $translate: ng.translate.ITranslateService) {
        }

        ngOnInit(){
            this.$translate('facets.facet.facet_' + this.facetGroup.name).then((translation)=>{
                this._facetGroupHeader= translation;},
                ()=>
                {this._facetGroupHeader= this.facetGroup.name;});

        }




    get facetGroupHeader(){
        return this._facetGroupHeader;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/facet/facetGroup.directive.ts